/* VAYKON — Protocol v2 */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement, win = window;
  var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = win.matchMedia && win.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var pad = function (n, l) { n = String(n); while (n.length < l) n = '0' + n; return n; };
  var mouse = { x: -9999, y: -9999 };
  win.addEventListener('pointermove', function (e) { mouse.x = e.clientX; mouse.y = e.clientY; }, { passive: true });

  /* Deterministic PRNG so every visitor sees the same "year". */
  function rng(seed) { return function () { seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296; }; }

  /* Run a rAF loop only while `el` is on screen and the tab is visible. */
  function whileVisible(el, frame) {
    var on = false, raf = 0, seen = false;
    function loop(t) { frame(t); raf = on ? requestAnimationFrame(loop) : 0; }
    function sync() { var want = seen && !doc.hidden; if (want && !on) { on = true; raf = requestAnimationFrame(loop); } else if (!want) { on = false; cancelAnimationFrame(raf); } }
    if ('IntersectionObserver' in win) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; sync(); }).observe(el);
    else { seen = true; }
    doc.addEventListener('visibilitychange', sync);
    sync();
  }

  /* ---------- Boot ---------- */
  function ready() { root.classList.add('vk-ready'); }
  if (root.classList.contains('vk-booting')) {
    var bootN = $('[data-vk-boot-n]'), bootBar = $('.vk-boot__bar i'), t0 = performance.now(), DUR = 1100;
    (function tick(t) {
      var p = clamp((t - t0) / DUR, 0, 1), e = 1 - Math.pow(1 - p, 3);
      if (bootN) bootN.textContent = pad(Math.round(e * 365), 3);
      if (bootBar) bootBar.style.setProperty('--p', e);
      if (p < 1) requestAnimationFrame(tick);
      else {
        root.classList.add('vk-booted');
        try { sessionStorage.setItem('vk-booted', '1'); } catch (err) {}
        setTimeout(ready, 150);
        setTimeout(function () { root.classList.remove('vk-booting', 'vk-booted'); }, 900);
      }
    })(t0);
  } else {
    requestAnimationFrame(function () { requestAnimationFrame(ready); });
  }

  /* ---------- Ambient field: slow drifting constellation ---------- */
  var cv = doc.getElementById('vk-field');
  if (cv && cv.getContext) {
    var ctx = cv.getContext('2d'), W, H, pts = [];
    var size = function () {
      var dpr = Math.min(win.devicePixelRatio || 1, 2);
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(70, (W * H) / 20000)), r = rng(7);
      pts = [];
      for (var i = 0; i < n; i++) pts.push({ x: r() * W, y: r() * H, vx: (r() - .5) * .14, vy: (r() - .5) * .14, s: r() * 1.1 + .3, z: r() });
    };
    var sy = 0;
    var draw = function () {
      ctx.clearRect(0, 0, W, H);
      var scroll = win.scrollY; sy += (scroll - sy) * .08;
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        if (!reduce) { p.x += p.vx; p.y += p.vy; }
        var py = ((p.y - sy * (.05 + p.z * .12)) % H + H) % H;
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
        var dx = p.x - mouse.x, dy = py - mouse.y, dm = Math.sqrt(dx * dx + dy * dy), g = dm < 180 ? 1 - dm / 180 : 0;
        ctx.fillStyle = 'rgba(255,255,255,' + (.18 + p.z * .2 + g * .6) + ')';
        ctx.fillRect(p.x, py, p.s + g * 1.5, p.s + g * 1.5);
        for (var j = i + 1; j < pts.length; j++) {
          var q = pts[j], qy = ((q.y - sy * (.05 + q.z * .12)) % H + H) % H, ex = p.x - q.x, ey = py - qy, d = ex * ex + ey * ey;
          if (d < 12000) {
            ctx.strokeStyle = 'rgba(255,255,255,' + (.05 * (1 - d / 12000) + g * .1) + ')';
            ctx.lineWidth = .6; ctx.beginPath(); ctx.moveTo(p.x, py); ctx.lineTo(q.x, qy); ctx.stroke();
          }
        }
      }
    };
    size(); draw();
    win.addEventListener('resize', function () { size(); draw(); });
    if (!reduce) whileVisible(cv, draw);
  }

  /* ---------- Hero orb: the year as a rotating sphere of 365 days ---------- */
  var orb = $('[data-vk-orb]');
  if (orb && orb.getContext) {
    var oc = orb.getContext('2d'), OW, OH, days = [], N = 365, r2 = rng(365);
    var golden = Math.PI * (3 - Math.sqrt(5));
    for (var d = 0; d < N; d++) {
      var y = 1 - (d / (N - 1)) * 2, rad = Math.sqrt(1 - y * y), th = golden * d;
      days.push({ x: Math.cos(th) * rad, y: y, z: Math.sin(th) * rad, hit: r2() < .82, at: 0 });
    }
    var dayEl = $('[data-vk-orb-day]'), onEl = $('[data-vk-orb-on]'), pctEl = $('[data-vk-orb-pct]');
    var rotY = 0, rotX = -.25, tRotX = -.25, tRotY = 0, sRotY = 0, cur = 0, lastStep = 0, onCount = 0, hitDone = 0;
    var osize = function () {
      var dpr = Math.min(win.devicePixelRatio || 1, 2);
      OW = orb.clientWidth; OH = orb.clientHeight;
      orb.width = OW * dpr; orb.height = OH * dpr; oc.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    var reset = function () { cur = 0; onCount = 0; hitDone = 0; days.forEach(function (p) { p.at = 0; }); };
    var ofr = function (t) {
      if (!OW) return;
      if (!reduce && t - lastStep > 55) {
        lastStep = t;
        if (cur >= N) { if (t - days[N - 1].at > 2600) reset(); }
        else { var p = days[cur]; p.at = t; hitDone++; if (p.hit) onCount++; cur++; }
      }
      var rect = orb.getBoundingClientRect();
      var mx = (mouse.x - (rect.left + OW / 2)) / OW, my = (mouse.y - (rect.top + OH / 2)) / OH;
      if (mouse.x > -9000) { tRotY = mx * 1.2; tRotX = -.25 + my * .8; }
      rotY += .0024; sRotY += (tRotY - sRotY) * .05; rotX += (tRotX - rotX) * .05;
      var ry = rotY + sRotY * .6;
      var cy = Math.cos(ry), sy2 = Math.sin(ry), cx = Math.cos(rotX), sx = Math.sin(rotX);
      var R = Math.min(OW, OH) * .36, ox = OW * .5, oy = OH * .5, persp = 3.2;
      oc.clearRect(0, 0, OW, OH);

      /* orbit rings */
      oc.lineWidth = 1;
      for (var k = 0; k < 3; k++) {
        var tilt = [.28, -.52, 1.1][k], rr = R * [1.32, 1.55, 1.18][k], spin = t * [.00012, -.00008, .0001][k];
        oc.beginPath();
        for (var a = 0; a <= 64; a++) {
          var an = a / 64 * Math.PI * 2 + spin, px = Math.cos(an) * rr, pz = Math.sin(an) * rr, py = pz * Math.sin(tilt); pz = pz * Math.cos(tilt);
          var X = px * cy - pz * sy2, Z = px * sy2 + pz * cy, Y = py * cx - Z * sx; Z = py * sx + Z * cx;
          var s = persp / (persp + Z / R); a === 0 ? oc.moveTo(ox + X * s, oy + Y * s) : oc.lineTo(ox + X * s, oy + Y * s);
        }
        oc.strokeStyle = 'rgba(255,255,255,' + [.1, .06, .08][k] + ')'; oc.stroke();
        var ba = t * [.0004, -.0003, .00035][k], bx = Math.cos(ba) * rr, bz = Math.sin(ba) * rr, byy = bz * Math.sin(tilt); bz = bz * Math.cos(tilt);
        var BX = bx * cy - bz * sy2, BZ = bx * sy2 + bz * cy, BY = byy * cx - BZ * sx; BZ = byy * sx + BZ * cx;
        var bs = persp / (persp + BZ / R); oc.fillStyle = 'rgba(255,255,255,' + (BZ < 0 ? .9 : .3) + ')'; oc.fillRect(ox + BX * bs - 2, oy + BY * bs - 2, 4, 4);
      }

      /* day points, sorted back-to-front */
      var proj = [];
      for (var i = 0; i < N; i++) {
        var p = days[i], X2 = p.x * cy - p.z * sy2, Z2 = p.x * sy2 + p.z * cy, Y2 = p.y * cx - Z2 * sx; Z2 = p.y * sx + Z2 * cx;
        proj.push({ i: i, X: X2, Y: Y2, Z: Z2 });
      }
      proj.sort(function (a, b) { return b.Z - a.Z; });
      var now = null;
      for (var j = 0; j < N; j++) {
        var q = proj[j], dd = days[q.i], sc = persp / (persp + q.Z), X3 = ox + q.X * R * sc, Y3 = oy + q.Y * R * sc;
        var front = (1 - q.Z) / 2, done = reduce ? dd.hit : (dd.at > 0), age = done && !reduce ? clamp((t - dd.at) / 400, 0, 1) : 1;
        var sz = (1.8 + front * 3.4) * sc;
        if (done && dd.hit) {
          var a2 = (.35 + front * .65) * age;
          oc.fillStyle = 'rgba(255,255,255,' + a2 + ')';
          var grow = sz * 1.35 * (1 + (1 - age) * 1.8);
          oc.fillRect(X3 - grow / 2, Y3 - grow / 2, grow, grow);
        } else {
          oc.strokeStyle = 'rgba(255,255,255,' + (.12 + front * .4) + ')';
          oc.lineWidth = .8; oc.strokeRect(X3 - sz / 2, Y3 - sz / 2, sz, sz);
        }
        if (!reduce && q.i === cur - 1) now = { x: X3, y: Y3, f: front };
      }
      if (now) {
        oc.strokeStyle = 'rgba(255,255,255,.85)'; oc.lineWidth = 1;
        var c = 12; oc.beginPath();
        oc.moveTo(now.x - c, now.y); oc.lineTo(now.x - 5, now.y); oc.moveTo(now.x + 5, now.y); oc.lineTo(now.x + c, now.y);
        oc.moveTo(now.x, now.y - c); oc.lineTo(now.x, now.y - 5); oc.moveTo(now.x, now.y + 5); oc.lineTo(now.x, now.y + c); oc.stroke();
        oc.font = '600 10px "JetBrains Mono", monospace'; oc.fillStyle = 'rgba(255,255,255,.8)';
        oc.fillText('ДЕН ' + pad(cur, 3), now.x + 16, now.y - 8);
      }
      if (dayEl) dayEl.textContent = pad(reduce ? N : Math.max(cur, 1), 3);
      if (onEl) onEl.textContent = reduce ? days.filter(function (p) { return p.hit; }).length : onCount;
      if (pctEl) pctEl.textContent = reduce ? 82 : (hitDone ? Math.round(onCount / hitDone * 100) : 0);
    };
    osize();
    win.addEventListener('resize', function () { osize(); if (reduce) ofr(0); });
    if (reduce) ofr(0); else whileVisible(orb, ofr);
  }

  /* ---------- Cursor ---------- */
  var cur$ = $('.vk-cursor');
  if (cur$ && fine && !reduce) {
    var ring = $('.vk-cursor__ring', cur$), dot = $('.vk-cursor__dot', cur$), rx = -100, ry = -100;
    (function loop() {
      rx += (mouse.x - rx) * .2; ry += (mouse.y - ry) * .2;
      dot.style.transform = 'translate3d(' + mouse.x + 'px,' + mouse.y + 'px,0)';
      ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)';
      requestAnimationFrame(loop);
    })();
    var HOV = 'a,button,summary,label,[role="button"],input,textarea';
    doc.addEventListener('pointerover', function (e) { cur$.classList.toggle('is-hover', !!(e.target.closest && e.target.closest(HOV))); });
    doc.addEventListener('pointerdown', function () { cur$.classList.add('is-down'); });
    doc.addEventListener('pointerup', function () { cur$.classList.remove('is-down'); });
    doc.addEventListener('pointerleave', function () { cur$.classList.add('is-hidden'); });
    doc.addEventListener('pointerenter', function () { cur$.classList.remove('is-hidden'); });
  }

  /* ---------- Magnetic buttons ---------- */
  if (fine && !reduce) {
    $$('[data-vk-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + x * .18 + 'px,' + y * .28 + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Text scramble (Cyrillic + glyphs) ---------- */
  var GLYPHS = 'АБВГДЕЖЗИКЛМНОПРСТУФХЦЧШЩЪЮЯ01#%▣◇✕/\\<>';
  function scramble(el) {
    if (el.__vkDone || reduce) return; el.__vkDone = true;
    var final = el.textContent, len = final.length, start = null, D = 700;
    el.setAttribute('aria-label', final);
    (function step(t) {
      if (!start) start = t;
      var p = clamp((t - start) / D, 0, 1), fixed = Math.floor(p * len), out = '';
      for (var i = 0; i < len; i++) {
        var ch = final[i];
        out += (i < fixed || ch === ' ' || ch === '·') ? ch : GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if (p < 1) requestAnimationFrame(step); else { el.textContent = final; el.removeAttribute('aria-label'); }
    })(performance.now());
  }

  /* ---------- Count up ---------- */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-vk-count')) || 0, t0 = null, D = 1400;
    if (reduce || to === 0) { el.textContent = to; return; }
    (function f(t) { if (!t0) t0 = t; var p = clamp((t - t0) / D, 0, 1), e = 1 - Math.pow(1 - p, 4); el.textContent = Math.round(to * e); if (p < 1) requestAnimationFrame(f); })(performance.now());
  }

  /* ---------- Reveal on scroll ---------- */
  var revealTargets = $$('[data-vk-reveal]');
  if ('IntersectionObserver' in win) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        $$('[data-vk-scramble]', e.target).forEach(scramble);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    revealTargets.forEach(function (el) { io.observe(el); });
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.target.hasAttribute('data-vk-count')) countUp(e.target); else scramble(e.target);
        io2.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-vk-scramble],[data-vk-count]').forEach(function (el) { if (!el.closest('[data-vk-reveal]')) io2.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Hero glitch ---------- */
  var title = $('.vk-hero__title');
  if (title && !reduce) setInterval(function () { if (doc.hidden) return; title.classList.remove('is-glitch'); void title.offsetWidth; title.classList.add('is-glitch'); }, 6400);

  /* ---------- Header: hide on scroll, progress, clock ---------- */
  var header = $('[data-vk-header]'), prog = $('[data-vk-progress]'), nav = doc.getElementById('vk-nav'), burger = $('[data-vk-burger]');
  var clock = $('[data-vk-clock]');
  if (clock) {
    var start = new Date(new Date().getFullYear(), 0, 0);
    var tickClock = function () {
      var n = new Date(), day = Math.floor((n - start) / 864e5);
      clock.textContent = 'ДЕН ' + pad(day, 3) + ' · ' + pad(n.getHours(), 2) + ':' + pad(n.getMinutes(), 2) + ':' + pad(n.getSeconds(), 2);
    };
    tickClock(); setInterval(tickClock, 1000);
  }
  if (burger && nav) {
    var setMenu = function (open) {
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      doc.body.style.overflow = open ? 'hidden' : '';
      if (header) header.classList.toggle('is-menu', open);
    };
    burger.addEventListener('click', function () { setMenu(!nav.classList.contains('is-open')); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) { setMenu(false); burger.focus(); } });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  }

  /* ---------- Scroll-driven scenes ---------- */
  var manifesto = $('[data-vk-manifesto]'), mWords = manifesto ? $$('.vk-mw', manifesto) : [];
  var year = $('[data-vk-year]'), yGrid = year && $('[data-vk-year-grid]', year), yCells = [], yPlan = [];
  if (yGrid) {
    var r3 = rng(2026), frag = doc.createDocumentFragment();
    for (var yi = 0; yi < 365; yi++) {
      var c = doc.createElement('i'); frag.appendChild(c); yCells.push(c);
      var bias = .6 + (yi / 365) * .32;
      yPlan.push(r3() < bias);
    }
    yGrid.appendChild(frag);
  }
  var yDay = year && $('[data-vk-year-day]', year), yOn = year && $('[data-vk-year-on]', year), yStreak = year && $('[data-vk-year-streak]', year), yShown = -1;
  var steps = $('[data-vk-steps]');
  var marquee = $('[data-vk-marquee]');
  var lastY = win.scrollY, ticking = false;

  function sceneProgress(el) {
    var r = el.getBoundingClientRect(), vh = win.innerHeight;
    return clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
  }
  function renderYear(n) {
    if (n === yShown) return;
    var on = 0, streak = 0, run = 0;
    for (var i = 0; i < 365; i++) {
      var cell = yCells[i], active = i < n;
      cell.className = active ? (yPlan[i] ? 'on' : 'miss') : '';
      if (active) { if (yPlan[i]) { on++; run++; streak = Math.max(streak, run); } else run = 0; }
    }
    if (n > 0 && n <= 365) yCells[n - 1].classList.add('now');
    if (yDay) yDay.textContent = pad(Math.max(n, 1), 3);
    if (yOn) yOn.textContent = on;
    if (yStreak) yStreak.textContent = streak;
    yShown = n;
  }
  function onScroll() {
    ticking = false;
    var y = win.scrollY, max = doc.documentElement.scrollHeight - win.innerHeight;
    if (prog) prog.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
    if (header && !(nav && nav.classList.contains('is-open'))) {
      header.classList.toggle('is-hidden', y > lastY && y > 240);
    }
    lastY = y;
    if (manifesto && mWords.length && !reduce) {
      var mp = sceneProgress(manifesto), lit = Math.round(clamp(mp * 1.25, 0, 1) * mWords.length);
      mWords.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); w.classList.toggle('is-now', i === lit - 1); });
    }
    if (yGrid) renderYear(reduce ? 365 : Math.round(clamp(sceneProgress(year) * 1.12, 0, 1) * 365));
    if (steps) {
      var sr = steps.getBoundingClientRect(), vh = win.innerHeight, isCol = win.innerWidth <= 760;
      var sp = clamp((vh * .8 - sr.top) / (sr.height * (isCol ? 1 : .6) + vh * .2), 0, 1);
      steps.style.setProperty('--p', reduce ? 1 : sp);
      var rail = $('.vk-steps__rail i', steps); if (rail) rail.style.setProperty('--p', reduce ? 1 : sp);
    }
  }
  win.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  win.addEventListener('resize', onScroll);
  onScroll();

  if (marquee && 'IntersectionObserver' in win) {
    new IntersectionObserver(function (es) { marquee.style.setProperty('--play', es[0].isIntersecting ? 'running' : 'paused'); }).observe(marquee);
  }

  /* ---------- Spotlight + tilt ---------- */
  if (fine) {
    $$('[data-vk-spotlight]').forEach(function (wrap) {
      wrap.addEventListener('pointermove', function (e) {
        var items = wrap.matches('.vk-cta__box') ? [wrap] : wrap.children;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          items[i].style.setProperty('--mx', (e.clientX - r.left) + 'px');
          items[i].style.setProperty('--my', (e.clientY - r.top) + 'px');
        }
      });
    });
    if (!reduce) {
      $$('[data-vk-tilt]').forEach(function (el) {
        var target = el.classList.contains('vk-gallery__stage') ? $('.vk-gallery__main', el) : el;
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          el.classList.add('is-tilting');
          target.style.setProperty('--ry', ((x - .5) * 8).toFixed(2) + 'deg');
          target.style.setProperty('--rx', ((.5 - y) * 8).toFixed(2) + 'deg');
          target.style.setProperty('--gx', (x * 100) + '%'); target.style.setProperty('--gy', (y * 100) + '%');
        });
        el.addEventListener('pointerleave', function () {
          el.classList.remove('is-tilting');
          target.style.setProperty('--ry', '0deg'); target.style.setProperty('--rx', '0deg');
        });
      });
    }
  }

  /* ---------- Footer word spotlight ---------- */
  var fw = $('[data-vk-footword]');
  if (fw) {
    var setFw = function (x, y) { fw.style.setProperty('--mx', x + 'px'); fw.style.setProperty('--my', y + 'px'); };
    if (fine) fw.addEventListener('pointermove', function (e) { var r = fw.getBoundingClientRect(); setFw(e.clientX - r.left, e.clientY - r.top); });
    else if (!reduce) whileVisible(fw, function (t) { var r = fw.getBoundingClientRect(); setFw(r.width * (.5 + .42 * Math.sin(t / 1400)), r.height * .5); });
    else fw.style.setProperty('--mx', '50%');
  }

  /* ---------- Interactive demo tracker ---------- */
  var demo = $('[data-vk-demo]');
  if (demo) {
    var ticks = $$('.vk-tick', demo), rows = $$('[data-vk-demo-row]', demo);
    var initial = ticks.map(function (b) { return b.getAttribute('aria-pressed'); });
    var el = function (s) { return $(s, demo); };
    var pctO = el('[data-vk-demo-pct]'), onO = el('[data-vk-demo-on]'), perfO = el('[data-vk-demo-perfect]'), bestO = el('[data-vk-demo-best]'), msgO = el('[data-vk-demo-msg]');
    var animNum = function (node, to) {
      var from = parseInt(node.textContent, 10) || 0; if (from === to || reduce) { node.textContent = to; return; }
      var t0 = null; (function f(t) { if (!t0) t0 = t; var p = clamp((t - t0) / 380, 0, 1); node.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(f); })(performance.now());
    };
    var MSG = [
      [0, 'Празна седмица. Никой няма да я отметне вместо теб.'],
      [1, 'Първата отметка е най-трудната. Продължавай.'],
      [40, 'Започва да прилича на навик.'],
      [70, 'Сериозно. Числата вече те уважават.'],
      [90, 'Машина. Така изглежда дисциплината.'],
      [100, 'Перфектна седмица. Сега я повтори 52 пъти.']
    ];
    var update = function () {
      var total = ticks.length, on = 0, cols = [0, 0, 0, 0, 0, 0, 0], best = null, bestV = -1;
      rows.forEach(function (row) {
        var bs = $$('.vk-tick', row), r = 0;
        bs.forEach(function (b, i) { if (b.getAttribute('aria-pressed') === 'true') { r++; on++; cols[i]++; } });
        var pct = Math.round(r / bs.length * 100), out = $('[data-vk-demo-rowpct]', row); if (out) out.textContent = pct;
        if (r > bestV) { bestV = r; best = $('.vk-sheet__name', row).textContent; }
      });
      var perfect = cols.filter(function (c) { return c === rows.length; }).length;
      var pct = total ? Math.round(on / total * 100) : 0;
      animNum(pctO, pct); animNum(onO, on); animNum(perfO, perfect);
      if (bestO) bestO.textContent = bestV > 0 ? best : '—';
      $$('[data-vk-demo-col]', demo).forEach(function (b) { var i = +b.getAttribute('data-vk-demo-col'); b.style.setProperty('--v', rows.length ? cols[i] / rows.length : 0); });
      if (msgO) { var m = MSG[0][1]; MSG.forEach(function (x) { if (on > 0 && pct >= x[0]) m = x[1]; }); if (on === 0) m = MSG[0][1]; msgO.textContent = m; }
    };
    ticks.forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && !reduce) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
        update();
      });
    });
    /* Arrow-key grid navigation */
    demo.addEventListener('keydown', function (e) {
      var i = ticks.indexOf(doc.activeElement); if (i < 0) return;
      var n = 7, j = { ArrowRight: i + 1, ArrowLeft: i - 1, ArrowDown: i + n, ArrowUp: i - n }[e.key];
      if (j === undefined) return; e.preventDefault(); if (ticks[j]) ticks[j].focus();
    });
    var reset = el('[data-vk-demo-reset]');
    if (reset) reset.addEventListener('click', function () {
      var cleared = ticks.every(function (b) { return b.getAttribute('aria-pressed') !== 'true'; });
      ticks.forEach(function (b, i) { b.setAttribute('aria-pressed', cleared ? initial[i] : 'false'); });
      reset.textContent = cleared ? 'Изчисти' : 'Върни';
      update();
    });
    update();
  }

  /* ---------- Product: consent gate (unchanged behaviour) ---------- */
  var form = doc.getElementById('vk-buy-form');
  if (form) {
    var box = form.querySelector('[data-vk-consent]'), btn = form.querySelector('[data-vk-buy]'), hint = form.querySelector('[data-vk-consent-hint]'), label = form.querySelector('.vk-consent');
    var soldOut = btn && btn.disabled;
    var sync = function () {
      if (!btn || soldOut) return;
      btn.classList.toggle('is-locked', !box.checked);
      btn.setAttribute('aria-disabled', box.checked ? 'false' : 'true');
      if (box.checked && hint) hint.hidden = true;
      if (box.checked && label) label.classList.remove('is-error');
    };
    if (box) { box.addEventListener('change', sync); sync(); }
    form.addEventListener('submit', function (e) {
      if (box && !box.checked) {
        e.preventDefault();
        if (hint) hint.hidden = false;
        if (label) { label.classList.remove('is-error'); void label.offsetWidth; label.classList.add('is-error'); }
        box.focus();
      }
    });

    /* Sticky mobile buy bar -> scrolls to the consent gate, never skips it */
    var sb = $('[data-vk-stickybuy]');
    if (sb && btn && 'IntersectionObserver' in win) {
      new IntersectionObserver(function (es) {
        var e = es[0]; sb.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
      $('[data-vk-stickybuy-go]', sb).addEventListener('click', function () {
        label.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { box.focus({ preventScroll: true }); if (!box.checked && hint) hint.hidden = false; }, reduce ? 0 : 450);
      });
    }
  }

  /* ---------- Product gallery ---------- */
  var gal = $('[data-vk-gallery]');
  if (gal) {
    var slides = $$('.vk-gallery__slide', gal), thumbs = $$('.vk-gallery__thumb', gal), idx = 0, gi = $('[data-vk-gal-i]', gal);
    var show = function (i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); if (k === idx) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } else t.removeAttribute('aria-current'); });
      if (gi) gi.textContent = pad(idx + 1, 2);
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-index')); }); });
    var prev = $('[data-vk-gal-prev]', gal), next = $('[data-vk-gal-next]', gal);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var main = $('.vk-gallery__main', gal), sx0 = null, sy0 = 0;
    if (main && slides.length > 1) {
      main.addEventListener('touchstart', function (e) { sx0 = e.touches[0].clientX; sy0 = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx0 === null) return; var dx = e.changedTouches[0].clientX - sx0, dy = e.changedTouches[0].clientY - sy0; sx0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
      });
    }
  }
})();
